import { createFileRoute } from '@tanstack/react-router'

import { BriefList } from '@/features/brief/BriefList'

export const Route = createFileRoute('/app/briefs/')({
  component: BriefsRoute,
})

/**
 * The briefs a buyer owns.
 *
 * This used to carry its own check for who was asking, and send a stranger to
 * the home page. It does not any more: it sits under `/app`, and everything
 * under `/app` is behind one gate that answers that question for all of them.
 * Two of them would be two answers to the same question, racing — and the one
 * that lost would be a redirect firing after the other had already moved on.
 */
function BriefsRoute() {
  return <BriefList />
}
